module.exports = [{"type":"title","text":"2025-11-25"},{"type":"normal","text":"Standardize input and output parameters, unifying them to BTC-USDT.","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Spot Trading: Upgraded the Spot ticker price endpoint from v1 to v2."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-11-25.json
// module id = ureo
// module chunks = 3